<script>
export default {
  props: {
    password: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      passwordLength: 0,
      containsEightCharacters: false,
      containsNumber: false,
      containsUppercase: false,
      containsLowercase: false,
      containsSpecialCharacter: false,
      validPassword: false,
    }
  },
  watch: {
    password(newValue, oldValue) {
      this.checkPassword()
    },
  },
  methods: {
    checkPassword() {
      this.passwordLength = this.password.length
      const format = /[ !@#$%^&*()_+\-=\]{};':"\\|,.<>?]/

      if (this.passwordLength > 8) {
        this.containsEightCharacters = true
      } else {
        this.containsEightCharacters = false
      }

      this.containsNumber = /\d/.test(this.password)
      this.containsUppercase = /[A-Z]/.test(this.password)
      this.containsLowercase = /[a-z]/.test(this.password)
      this.containsSpecialCharacter = format.test(this.password)

      if (
        this.containsEightCharacters === true &&
        this.containsSpecialCharacter === true &&
        this.containsUppercase === true &&
        this.containsLowercase === true &&
        this.containsNumber === true
      ) {
        this.validPassword = true
      } else {
        this.validPassword = false
      }
    },
  },
}
</script>

<template>
  <div
    v-show="password !== ''"
    :class="[$style.terms, $style.passValidContainer]"
  >
    <p>The password must contain at least:</p>
    <ul>
      <li
        :class="[{ [$style.isValid]: containsEightCharacters }, $style.passLi]"
        >8 Characters</li
      >
      <li :class="[{ [$style.isValid]: containsNumber }, $style.passLi]"
        >Contains Number</li
      >
      <li :class="[{ [$style.isValid]: containsUppercase }, $style.passLi]"
        >Contains Uppercase</li
      >
      <li :class="[{ [$style.isValid]: containsLowercase }, $style.passLi]"
        >Contains Lowercase</li
      >
      <li
        :class="[{ [$style.isValid]: containsSpecialCharacter }, $style.passLi]"
        >Contains Special Character</li
      >
    </ul>
  </div>
</template>

<style lang="scss" module>
@import '@design';
.passLi {
  position: relative;
  margin-bottom: 8px;
  color: #525f7f;
}

.passLi::before {
  position: absolute;
  top: 50%;
  left: 0;
  display: block;
  width: 0%;
  height: 2px;
  content: '';
  background: #2ecc71;
  transition: all 0.6s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.terms {
  margin-bottom: 10px;
  text-align: left;
}

.isValid {
  color: rgba(136, 152, 170, 0.8);
}
.isValid::before {
  width: 100%;
}

.passList {
  color: red;
}
</style>
